import { FolderInput } from "lucide-react";

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

/**
 * Produto novo que veio sem categoria na planilha (regra do dono, 29/09/2026):
 * não entra sem categoria — a loja escolhe aqui, antes de aplicar. A lista é a
 * das categorias da loja mais as que a própria planilha vai criar.
 */
function Escolha({ valor, opcoes, onChange, placeholder = "Escolha a categoria" }) {
  return (
    <Select value={valor || undefined} onValueChange={onChange}>
      <SelectTrigger className="h-9 w-full sm:w-56 text-xs bg-background">
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="max-h-72">
        {opcoes.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}

export default function EscolherCategorias({ produtos, opcoes, escolhas, onEscolher, onEscolherTodos }) {
  if (!produtos.length) return null;
  const faltam = produtos.filter((n) => !escolhas[n.linha]).length;
  return (
    <div className="rounded-xl border border-amber-300 bg-amber-50 dark:bg-amber-950/30 dark:border-amber-800">
      <div className="flex gap-2 px-3 py-2.5 text-xs">
        <FolderInput className="w-4 h-4 text-amber-600 shrink-0" />
        <span>
          {produtos.length === 1 ? "1 produto novo veio" : `${produtos.length} produtos novos vieram`} sem categoria na
          planilha. Produto não entra sem categoria: escolha abaixo antes de aplicar.
          {faltam > 0 && <strong className="ml-1">Faltam {faltam}.</strong>}
        </span>
      </div>
      {produtos.length > 1 && (
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 border-t border-amber-200 dark:border-amber-900 px-3 py-2 text-xs">
          <span className="font-medium">Colocar todos em</span>
          <Escolha valor="" opcoes={opcoes} onChange={onEscolherTodos} placeholder="Escolher para todos" />
        </div>
      )}
      <div className="border-t border-amber-200 dark:border-amber-900 divide-y divide-amber-200 dark:divide-amber-900 max-h-64 overflow-y-auto">
        {produtos.map((n) => (
          <div key={n.linha} className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 px-3 py-2 text-xs" data-e2e="sem-categoria">
            <div className="min-w-0">
              <div className="text-sm font-medium truncate">{n.nome}</div>
              <div className="text-muted-foreground">Linha {n.linha}</div>
            </div>
            <Escolha valor={escolhas[n.linha]} opcoes={opcoes} onChange={(c) => onEscolher(n.linha, c)} />
          </div>
        ))}
      </div>
    </div>
  );
}
